<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-btn">
                <el-button
                  type="text"
                  @click="editOTA"
                  :disabled="this.selected.length == 0"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  type="text"
                  @click="deleteOTA"
                  :disabled="this.selected.length == 0"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button type="text" @click="addOTA">{{
                  $t("OTAManagement.btn.addOTA")
                }}</el-button>
                <el-button type="text" @click="BulkImport()">{{
                  $t("OTAManagement.btn.downloadFile")
                }}</el-button>
                <el-button @click="ListSetting" type="text">{{
                  $t("common.btn.listsetting")
                }}</el-button>
                <i-column
                  :listData="columns"
                  @changeSort="changeSort"
                  ref="listSet"
                ></i-column>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            :label="$t('OTAManagement.typeIdStr') + ':'"
            :label-width="formLabelWidth"
            prop="typeId"
          >
            <el-select
              @change="indexSelect()"
              v-model="form.typeId"
              :placeholder="$t('OTAManagement.form.typeId')"
            >
              <el-option
                v-for="item in terminalList"
                :key="item.id"
                :label="item.terminalType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="no"
            :label="$t('OTAManagement.firmwareVersion') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.no"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="defaultVersion"
            :label-width="formLabelWidth"
            style="width: 100%"
          >
            <el-checkbox v-model="form.defaultVersion">{{
              $t("OTAManagement.defaultVersion")
            }}</el-checkbox>
          </el-form-item>
          <!-- <el-form-item
            :label="$t('OTAManagement.form.uploadFile') + ':'"
            :label-width="formLabelWidth"
            prop="uploadFile"
          >
            <input @change="uploadFile()" id="uploadDom" type="file" />
          </el-form-item> -->
          <el-form-item
            v-if="btnType !== 'edit'"
            :label="$t('OTAManagement.form.uploadFile') + ':'"
            :label-width="formLabelWidth"
            prop="uploadFile"
          >
            <input @change="uploadFile()" id="uploadDom" type="file" />
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.form.groupId') + ':'"
            :label-width="formLabelWidth"
            prop="groupId"
          >
            <el-select
              @change="changeStatus"
              v-model="form.groupId"
              :placeholder="$t('OTAManagement.form.groupId')"
            >
              <el-option
                :label="$t('OTAManagement.form.terminalId')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('OTAManagement.form.uploadTerminal')"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.form.terminalId') + ':'"
            :label-width="formLabelWidth"
            v-if="groupStatus"
          >
            <el-input
              disabled
              class="fuInput"
              v-model="form.carIds"
              placeholder=""
            ></el-input>
            <el-button
              class="fuButton"
              size="small"
              icon="el-icon-plus"
              @click="getNewCarInfo"
              >{{ $t("OTAManagement.form.terminalId") }}</el-button
            >
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.form.uploadTerminalFile') + ':'"
            :label-width="formLabelWidth"
            v-else
          >
            <el-upload
              class="upload-demo"
              :action="processFile"
              :on-success="handleSuccess"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple
              :file-list="FileList"
            >
              <el-button size="small" type="primary">{{
                $t("common.btn.clickUploadFile")
              }}</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
                style="width: 200px; display: inline-block; margin-left: 10px"
              >
                {{ $t("OTAManagement.btn.onlySpecialFile") }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            prop="describe"
            :label="$t('OTAManagement.form.describe') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.describe"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('OTAManagement.addTermianlSetting')"
        :visible.sync="dialogVisibleTransfer"
        width="1200px"
        :before-close="handleClose"
        class="addDialong"
        :close-on-click-modal="false"
      >
        <span
          ><i-Terminal
            v-if="delTransfer"
            ref="transfer"
            @postParam="postParam"
            :paramsData="paramsData"
          ></i-Terminal
        ></span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisibleTransfer = false">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="assignment">{{
            $t("common.btn.confirm")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import OTAManagement from "./OTAManagement";
export default OTAManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
